import React, { useEffect, useRef, useState } from "react";
import { FormControl } from "components/template";
import { Input } from "components/atoms";
import {countries} from "_utilities/countries";

const prefix = "o-dial-code";

const DialCode = ({
  countryDefault = countries.filter(({ iso }) => iso === "mx").pop(),
  errors,
  labelProps,
  onChangeCountry = () => {},
  inputProps,
  props
}) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(countryDefault);
  const dropdownRef = useRef();
  
  const selectHandler = (country) => {
    setOpen(false);
    setSelected(country);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    onChangeCountry(selected);
  }, [selected]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={prefix}>
      <FormControl
        className="flex-none"
        errors={errors}
        label="Número de teléfono"
        labelProps={labelProps}
        orientation="vertical"
        showErrors={true}
        {...props}
      >
        <div className="flex flex-wrap flex-row w-full gap-2">
          <div ref={dropdownRef} className="relative flex-none">
            <div
              className="flex flex-wrap gap-2 items-center px-3 bg-gray-100 cursor-pointer rounded-lg h-10"
              onClick={() => setOpen(!open)}
            >
              <span className={`fi fi-${selected?.iso}`}></span>
              <span>{selected.dialCode}</span>
            </div>

            {open && (
              <div
                className="absolute top-full p-2left-0 mt-1 w-[200px] shadow-md bg-white max-h-[150px] overflow-y-auto rounded-lg z-50"
              >
                {countries.map((country) => (
                  <div
                    className="p-2 cursor-pointer flex flex-row justify-between"
                    key={country.iso}
                    onClick={() => selectHandler(country)}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#f0f0f0")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "white")
                    }
                  >
                    <span className="flex flex-wrap gap-2">
                      <span className={`fi fi-${country.iso}`}></span>
                      {country.name}
                    </span>
                    <span>{country.dialCode}</span>
                  </div>
                ))}
              </div>
            )}
          </div>

          <Input 
            {...inputProps}
            onBeforeInput={(e) => {
              if (!/^\d$/.test(e.data)) {
                e.preventDefault(); // previene letras y símbolos
              }
            }}
            inputMode="numeric"
            maxLength={10}
            size="flex-auto h-10"
          />
        </div>
      </FormControl>
    </div>
  );
};

export default DialCode;
